import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-testid": "nav-bar--manage-build-group-button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "incredicon-edit-build-group !text-[20px] text-Text/text_high !mr-0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-Text/text_high" }, "Build Groups", -1)

import { IncrediButton, useIncrediDialog } from 'incredi-ui';
import manageBuildGroupsDialog from '@/views/agents/components/buildGroups/manageBuildGroupsDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-build-groups-btn',
  setup(__props) {

const dialog = useIncrediDialog();

const openDialog = () => {
  dialog?.open('manageBuildGroupsDialog', manageBuildGroupsDialog, {});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IncrediButton), {
      design: "ghost-grey",
      size: "small",
      onClick: openDialog,
      class: "whitespace-nowrap !px-[4px]"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}
}

})